import { render, staticRenderFns } from "./guJinYiYi.vue?vue&type=template&id=55b48ad6&scoped=true&"
import script from "./guJinYiYi.vue?vue&type=script&lang=js&"
export * from "./guJinYiYi.vue?vue&type=script&lang=js&"
import style0 from "./guJinYiYi.vue?vue&type=style&index=0&id=55b48ad6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b48ad6",
  null
  
)

export default component.exports